import React from "react";
import Todo from "./Todo";
import style from "./todos.module.css";
const Todos = (props) => {
  return (
    <section className={style.todos}>
      {props.todos.map((todo, index) => (
        <Todo
          key={todo.id}
          todo={todo.todoInner}
          id={todo.id}
          onRemoveItem={props.onRemoveTodo}
        />
      ))}
    </section>
  );
};

export default Todos;
